import { AppPalette } from '../colors'

export const darkPalette = {
  primary: {
    main: AppPalette.NEUTRAL.white,
    contrastText: AppPalette.GREEN.second,
  },
  text: {
    main: AppPalette.GREY.secondary,
    secondary: AppPalette.GREY.dark,
  },
  /**
   * The dark theme had no `grey` scale at all, so every `grey.600` /
   * `grey.700` / `grey.800` in the app fell through to MUI's defaults —
   * #757575 and #424242, i.e. dark grey text on a dark background. In the flow
   * alarm panel that put section labels at 1.67:1 and the unit suffix at
   * 1.05:1, effectively invisible.
   *
   * The scale is inverted relative to light: there 800 is the darkest and
   * strongest against white, here it is the lightest and strongest against
   * navy, so the "higher number = more prominent" ordering still holds and
   * existing call sites keep their intent.
   */
  grey: {
    600: '#9FB3BD',
    700: '#B5C2CB',
    800: AppPalette.GREY.secondary,
  },
  background: {
    // MUI derives `paper` from palette.mode when it is not set, which paints
    // every menu, popover and default Paper #121212 — a black panel against
    // this app's navy. Give it the raised surface the rest of the theme uses.
    paper: AppPalette.NEUTRAL.input,
    default: AppPalette.NEUTRAL.darker,
    overrideDefault: AppPalette.NEUTRAL.input,
    dark: AppPalette.NEUTRAL.darker,
    dialog: AppPalette.NEUTRAL.second,
    secondary: AppPalette.NEUTRAL.dark,
    bgIcon: AppPalette.GREY.fourth,
    bgIconFirst: AppPalette.BORDER.darker,
    hoverFirst: AppPalette.GREY.highlight_dark,
    bgButton: AppPalette.GREY.third,
  },
  highlight: {
    main: AppPalette.GREY.highlight_dark,
  },
  link: {
    main: AppPalette.BLUE.secondary,
  },
  overdueState: {
    overdue: AppPalette.SLA_STATE.overdue_dark,
    on_time: AppPalette.SLA_STATE.on_time_dark,
  },
  createTicketBackground: {
    main: AppPalette.NEUTRAL.darker,
  },
  border: {
    main: AppPalette.BORDER.dark,
    first: AppPalette.BORDER.darkBold,
    devider: AppPalette.BORDER.darker,
  },
  error: {
    main: AppPalette.RED.dark,
    light: AppPalette.RED.error,
  },
  color: {
    button: {
      icon: '#004744',
      label: '#004744',
      labelActive: '#66f0a0',
    },
    label: '#fff',
    chip: {
      label: '#fff',
      labelActive: '#66f0a0',
    },
    border: {
      box: '#1a3746',
    },
    text: {
      black: '#fff',
      white: '#000',
      tabHeaderActive: '#66f0a0',
      table: {
        header: '#002031',
        body: '#fff',
      },
    },
  },
  backgroundColor: {
    box: '#002031',
    wrapper: '#1a3746',
    table: {
      rowActive: '#9bb5b4',
    },
  },
}
